<div #wrapper>
  <ng-container *ngIf="showLoadingSkeleton; else sidebarTemplate">
    <ng-container *ngTemplateOutlet="skeletonTemplate"></ng-container>
  </ng-container>

  <!-- Sidebar template -->
  <ng-template #sidebarTemplate>
    <div
      role="listbox"
      tabindex="0"
      aria-label="Search Filters"
      class="search-filters-sidebar l_flex l_flex-column"
    >
      <ng-container *ngIf="!isModal; else filtersTemplate">
        <!-- Filters -->
        <div
          #fixedSidebar
          class="l_flex l_flex-column search-filters-sidebar--options"
        >
          <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
        </div>

        <!-- Reset button -->
        <div
          #resetButton
          *ngIf="showFilterReset"
          class="search-filters-sidebar--reset"
        >
          <button
            class="search-filters-sidebar--reset-button"
            df-button
            dfButtonType="primary"
            data-dgat="search-filters-sidebar-c2c"
            (click)="onFilterReset()"
          >
            {{ resetFiltersText }}
          </button>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>

<!-- Filters template -->
<ng-template #filtersTemplate>
  <ng-container
    *ngFor="let filter of filters"
    data-dgat="search-filters-sidebar-e43"
  >
    <dgx-search-filter-sidebar
      *ngIf="showFilter(filter)"
      [filter]="filter"
      [isExpanded]="isFilterExpanded(filter)"
      (toggleFilter)="onToggle($event)"
      (filterChange)="filterChange($event)"
    ></dgx-search-filter-sidebar>
  </ng-container>
</ng-template>

<!-- Loading skeleton template -->
<ng-template #skeletonTemplate>
  <span class="h4">{{ 'UserController_Loading' | translate }}</span>
  <dgx-skeleton
    type="search-filter-sidebar"
    data-dgat="search-filters-sidebar-661"
  ></dgx-skeleton>
</ng-template>
